document.addEventListener("DOMContentLoaded", function() {

/* ============================================================
   1. DAAL & MUIS CAROUSEL LOGIC
   ============================================================ */

  function initSlider(slider) {
    // Voorkom dubbele initialisatie
    if (slider.dataset.dmInitialized) return;
    slider.dataset.dmInitialized = "1";

    var images = slider.querySelectorAll('.dm-carousel-img');
    var prevBtn = slider.querySelector('.js-dm-prev');
    var nextBtn = slider.querySelector('.js-dm-next');

    // Safety check
    if (!prevBtn || !nextBtn || images.length < 2) return;

    var activeIndex = 0;

    // Functie om de juiste foto class te geven
    function updateImages() {
      images.forEach(function(img, index) {
        // Toggle de 'is-active' class (CSS regelt de opacity)
        img.classList.toggle('is-active', index === activeIndex);
      });
    }

    // Zet de slider in 'handmatige modus' zodat de CSS hover-reveal stopt
    function enableManualMode() {
      slider.classList.add('dm-manual-mode');
    }

    // --- VOLGENDE KNOP ---
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();

      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      // Check: Zitten we in 'Hover Reveal' modus? (Alleen Desktop)
      var isHoverMode = isDesktop && !slider.classList.contains('dm-manual-mode') && slider.matches(':hover') && activeIndex === 0;

      if (isHoverMode) {
        // Gebruiker ziet foto 2 al door hover. Klik rechts = ga naar foto 3 (index 2).
        activeIndex = 2;
      } else {
        activeIndex = activeIndex + 1;
      }

      if (activeIndex >= images.length) activeIndex = 0;
      enableManualMode();
      updateImages();
    });

    // --- VORIGE KNOP ---
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation();

      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var isHoverMode = isDesktop && !slider.classList.contains('dm-manual-mode') && slider.matches(':hover') && activeIndex === 0;

      if (isHoverMode) {
        // Gebruiker ziet foto 2. Klik links = terug naar foto 1 (index 0).
        activeIndex = 0;
      } else {
        activeIndex = activeIndex - 1;
        if (activeIndex < 0) activeIndex = images.length - 1;
      }

      enableManualMode();
      updateImages();
    });

    // --- RESET BIJ WEGGAAN MUIS (Desktop Only) ---
    slider.addEventListener('mouseleave', function() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        slider.classList.remove('dm-manual-mode');
        activeIndex = 0;
        updateImages();
      }
    });
  }

  // Initialiseer alle sliders die al in de DOM staan
  document.querySelectorAll('.js-dm-slider').forEach(initSlider);

  // Initialiseer ook sliders die later dynamisch worden toegevoegd (bijv. product-recommendations)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('js-dm-slider')) {
          initSlider(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.js-dm-slider').forEach(initSlider);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

/* ============================================================
   2. USP SLIDER LOGIC
   ============================================================ */

  const sliderContainer = document.querySelector('.announcement-bar__message');
  if (sliderContainer) {
    // Filter items
    let items = Array.from(sliderContainer.childNodes).filter(child => {
      return child.nodeType === 1 && child.classList.contains('usp-item');
    });

    if (items.length >= 2) {
      // Maak clone indien nog niet aanwezig
      if (!sliderContainer.querySelector('.usp-clone')) {
        const firstItemClone = items[0].cloneNode(true);
        firstItemClone.classList.add('usp-clone');
        sliderContainer.appendChild(firstItemClone);
      }

      const totalSlides = items.length + 1;
      let currentIndex = 0;

      // Forceer startpositie
      sliderContainer.style.justifyContent = 'flex-start';
      sliderContainer.style.transform = 'translateX(0)';

      function runSlider() {
        // Desktop check
        if (window.innerWidth > 749) {
          sliderContainer.style.transform = '';
          sliderContainer.style.justifyContent = ''; // Reset voor desktop
          return;
        }

        // Pauzeer bij hover
        if (window.matchMedia('(hover: hover)').matches && sliderContainer.matches(':hover')) {
          return;
        }

        currentIndex++;

        sliderContainer.style.transition = 'transform 0.5s ease-in-out';
        sliderContainer.style.transform = `translateX(-${currentIndex * 100}%)`;

        if (currentIndex === totalSlides - 1) {
          setTimeout(() => {
            sliderContainer.style.transition = 'none';
            currentIndex = 0;
            sliderContainer.style.transform = `translateX(0)`;
          }, 500);
        }
      }

      setInterval(runSlider, 3000);
    }
  }

});